<template>
  <div class="app-help">
    <b-tabs vertical pills nav-wrapper-class="app-help-nav-wrapper" class="app-help-tabs">
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" />
          <span>{{ $t('HELP_ABOUT.Title') }}</span>
        </template>
        <app-about></app-about>
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="MonitorIcon" size="16" />
          <span>{{ $t('HELP_VERSION.Title') }}</span>
        </template>
        <app-version></app-version>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab } from "bootstrap-vue";
import AppAbout from "./AppAbout.vue";
import AppVersion from "./AppVersion.vue";

export default {
  components: {
    BTabs,
    BTab,
    AppAbout,
    AppVersion,
  },
};
</script>

<style lang="scss" scoped>
.app-help {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.app-help-tabs {
  flex: 1;
}
</style>
